import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RoutingInterfaceFilterService {

  constructor() {}

  public static filter(rIs: any, searchObject: any): any {
    let filteredRIs;

    const filterByNodesId = (routingInterfaces, nodeId) => {
      if (nodeId) {
        routingInterfaces = routingInterfaces.filter((rI) => {
          return rI.nodeId === nodeId;
        });
      }
      return routingInterfaces;
    };

    if (!searchObject) {
      return rIs;
    }

    if (searchObject.nodeId) {
      filteredRIs = filterByNodesId(rIs, searchObject.nodeId);
      return filteredRIs;
    }
  }
}
